'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const breakpoints = {
  mobile: 375,
  tablet: 768
};
const backgroundColorMap = {
  ocean40: "night",
  sun60: "moss",
  lava60: "zapier",
  white: "neutral100",
  neutral100: "neutral100",
  zapier: "zapier",
  night: "night",
  moss: "moss",
  neutral800: "neutral800"
};

exports.backgroundColorMap = backgroundColorMap;
exports.breakpoints = breakpoints;
//# sourceMappingURL=constants.cjs.js.map
